import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	conf: 'sn/phone/conf',
};

export const phoneApi = createApi({
	reducerPath: 'sn/phoneApi',

	endpoints: (builder) => ({
		conf: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/sn/phone/conf?${qs.stringify(body)}`,
			}),
			providesTags: [tags.conf],
		}),
	}),
});

export const {
	conf,
} = phoneApi.endpoints;

export default phoneApi;